import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class PurchaseSample extends Component {
    getOrderId() {
        const { progLangId } = this.props;
        switch(progLangId) {
            case _DOTNET:
                return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
            case _JAVA:
                return `"Test"+createDate.getTime()`;
            case _PHP:
                return `'ord-'.date("dmy-G:i:s")`;
            default:
                return "";
        }
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken, pan, expdate, amount, currency } = this.props;

        return (
            <pre className="sampleCode">
{`using System;
using System.Collections.Generic;
using System.Text;

using Moneris;

namespace CanadaPurchaseConsoleTest
{ 
 class CanadaPurchaseTest
 { 
  public static void Main(string[] args)
  { 
   string order_id = ${this.getOrderId()};
   string store_id = "`}{this.getValue(storeId, "storeId")}{`";
   string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
   string amount = "`}{this.getValue(amount, "amount")}{`";
   string pan = "`}{this.getValue(pan, "pan")}{`";
   string expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
   string crypt = "7";
   string processing_country_code = "CA";
   bool status_check = false;
   CofInfo cof = new CofInfo();
   cof.SetPaymentIndicator("U");
   cof.SetPaymentInformation("2");
   cof.SetIssuerId("12345678901234");
   Purchase purchase = new Purchase();
   purchase.SetOrderId(order_id);
   purchase.SetAmount(amount);
   purchase.SetPan(pan);
   purchase.SetExpDate("2011");
   purchase.SetCryptType(crypt);
   purchase.SetDynamicDescriptor("2134565");

   //purchase.SetWalletIndicator(""); //Refer to documentation for details
   purchase.SetCofInfo(cof);

   //Optional - Set for Multi-Currency only
   //setAmount must be 0.00 when using multi-currency
   //purchase.SetMCPAmount("500"); //penny value amount 1.25 = 125
   //purchase.SetMCPCurrencyCode("`}{this.getValue(currency, "currency")}{`"); //ISO-4217 country currency number
   HttpsPostRequest mpgReq = new HttpsPostRequest();
   mpgReq.SetProcCountryCode(processing_country_code);
   mpgReq.SetTestMode(true); //false or comment out this line for production transactions
   mpgReq.SetStoreId(store_id);
   mpgReq.SetApiToken(api_token);
   mpgReq.SetTransaction(purchase);
   mpgReq.SetStatusCheck(status_check);
   mpgReq.Send();

   try
   { 
    Receipt receipt =
    mpgReq.GetReceipt();
    Console.WriteLine("CardType = " + receipt.GetCardType());
    Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
    Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
    Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
    Console.WriteLine("TransType = " + receipt.GetTransType());
    Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
    Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
    Console.WriteLine("ISO = " + receipt.GetISO());
    Console.WriteLine("BankTotals = " + receipt.GetBankTotals());
    Console.WriteLine("Message = " + receipt.GetMessage());
    Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
    Console.WriteLine("Complete = " + receipt.GetComplete());
    Console.WriteLine("TransDate = " + receipt.GetTransDate());
    Console.WriteLine("TransTime = " + receipt.GetTransTime());
    Console.WriteLine("Ticket = " + receipt.GetTicket());
    Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
    Console.WriteLine("IsVisaDebit = " + receipt.GetIsVisaDebit());
    Console.WriteLine("HostId = " + receipt.GetHostId());
    Console.WriteLine("MCPAmount = " + receipt.GetMCPAmount());
    Console.WriteLine("MCPCurrencyCode = " + receipt.GetMCPCurrencyCode());
    Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
    Console.ReadLine();
   } 
   catch (Exception e) 
   { 
    Console.WriteLine(e);
   }
  }
 }
}
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken, pan, expdate, amount } = this.props;

        return (
            <pre className="sampleCode">
{`public class TestCanadaPurchase
{
 public static void main(String[] args)
 { 
  java.util.Date createDate = new java.util.Date();
  String order_id = ${this.getOrderId()};
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  String amount = "`}{this.getValue(amount, "amount")}{`";
  String pan = "`}{this.getValue(pan, "pan")}{`";
  String expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
  String crypt = "7";
  String processing_country_code = "CA";
  boolean status_check = false;
  Purchase purchase = new Purchase();
  purchase.setOrderId(order_id);
  purchase.setAmount(amount);
  purchase.setPan(pan);
  purchase.setExpdate(expdate);
  purchase.setCryptType(crypt);
  purchase.setDynamicDescriptor("123456");

  //purchase.setWalletIndicator(""); //Refer documentation for possible values
  purchase.setCmId("8nAK8712sGaAkls56"); //set only for usage with Offlinx - Unique max 50
  alphanumeric characters transaction id generated by merchant

  //optional - Credential on File details
  CofInfo cof = new CofInfo();
  cof.setPaymentIndicator("U");
  cof.setPaymentInformation("2");
  cof.setIssuerId("139X3130ASCXAS9");

  purchase.setCofInfo(cof);

  HttpsPostRequest mpgReq = new HttpsPostRequest();
  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(purchase);
  mpgReq.setStatusCheck(status_check);

  //Optional - Proxy
  mpgReq.setProxy(false); //true to use proxy
  mpgReq.setProxyHost("proxyURL");
  mpgReq.setProxyPort("proxyPort");
  mpgReq.setProxyUser("proxyUser"); //optional - domainName\\User
  mpgReq.setProxyPassword("proxyPassword"); //optional

  mpgReq.send();

  try
  { 
   Receipt receipt = mpgReq.getReceipt();
   System.out.println("CardType = " + receipt.getCardType());
   System.out.println("TransAmount = " + receipt.getTransAmount());
   System.out.println("TxnNumber = " + receipt.getTxnNumber());
   System.out.println("ReceiptId = " + receipt.getReceiptId());
   System.out.println("TransType = " + receipt.getTransType());
   System.out.println("ReferenceNum = " + receipt.getReferenceNum());
   System.out.println("ResponseCode = " + receipt.getResponseCode());
   System.out.println("ISO = " + receipt.getISO());
   System.out.println("BankTotals = " + receipt.getBankTotals());
   System.out.println("Message = " + receipt.getMessage());
   System.out.println("AuthCode = " + receipt.getAuthCode());
   System.out.println("Complete = " + receipt.getComplete());
   System.out.println("TransDate = " + receipt.getTransDate());
   System.out.println("TransTime = " + receipt.getTransTime());
   System.out.println("Ticket = " + receipt.getTicket());
   System.out.println("TimedOut = " + receipt.getTimedOut());
   System.out.println("IsVisaDebit = " + receipt.getIsVisaDebit());
   System.out.println("HostId = " + receipt.getHostId());
   System.out.println("MCPAmount = " + receipt.getMCPAmount());
   System.out.println("MCPCurrencyCode = " + receipt.getMCPCurrencyCode());
   System.out.println("IssuerId = " + receipt.getIssuerId());
   } 
   catch (Exception e)
   {
    e.printStackTrace();
   }
  }
 }
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken, pan, expdate, amount } = this.props;

        return (
            <pre className="sampleCode">
{`<?php
##
## Example php -q TestPurchase.php store1
##

require "../../mpgClasses.php";

/**************************** Request Variables *******************************/
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';

/************************* Transactional Variables ****************************/
$type='purchase';
$cust_id='cust id';
$order_id='ord-'.date("dmy-G:i:s");
$amount='`}{this.getValue(amount, "amount")}{`';
$pan='`}{this.getValue(pan, "pan")}{`';
$expiry_date='`}{this.getValue(expdate, "expdate")}{`';
$crypt='7';
$dynamic_descriptor='123';
$status_check = 'false';

/*********************** Transactional Associative Array **********************/
$txnArray=array('type'=>$type,
 'order_id'=>$order_id,
 'cust_id'=>$cust_id,
 'amount'=>$amount,
 'pan'=>$pan,
 'expdate'=>$expiry_date,
 'crypt_type'=>$crypt,
 'dynamic_descriptor'=>$dynamic_descriptor
 //,'wallet_indicator' => '' //Refer to documentation for details
 //,'cm_id' => '8nAK8712sGaAkls56' //set only for usage with Offlinx - Unique max 50 alphanumeric
 characters transaction id generated by merchant
);

/**************************** Transaction Object *****************************/
$mpgTxn = new mpgTransaction($txnArray);

/******************* Credential on File **********************************/
$cof = new CofInfo();
$cof->setPaymentIndicator("U");
$cof->setPaymentInformation("2");
$cof->setIssuerId("168451306048014");
$mpgTxn->setCofInfo($cof);

/****************************** Request Object *******************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions

/***************************** HTTPS Post Object *****************************/
/* Status Check Example
$mpgHttpPost =new mpgHttpsPostStatus($store_id,$api_token,$status_check,$mpgRequest);
*/
$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);

/******************************* Response ************************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();

print("\\nCardType = " . $mpgResponse->getCardType());
print("\\nTransAmount = " . $mpgResponse->getTransAmount());
print("\\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nTransType = " . $mpgResponse->getTransType());
print("\\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nISO = " . $mpgResponse->getISO());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nIsVisaDebit = " . $mpgResponse->getIsVisaDebit());
print("\\nAuthCode = " . $mpgResponse->getAuthCode());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTicket = " . $mpgResponse->getTicket());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nStatusCode = " . $mpgResponse->getStatusCode());
print("\\nStatusMessage = " . $mpgResponse->getStatusMessage());
print("\\nHostId = " . $mpgResponse->getHostId());
print("\\nIssuerId = " . $mpgResponse->getIssuerId());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, orderId, pan, expdate, amount, currency, onEditId } = state.transactions.main.config;
    const { selection } = state.common.progLangList;
    return { storeId, apiToken, orderId, pan, expdate, amount, currency, onEditId, progLangId: selection };
  }
  
  export default connect(mapStateToProps, {})(PurchaseSample)